import React, { useEffect, useRef, useState } from "react";
import { TextLg, TextMd, TextSm } from "../../components/text";
import phoneIcon from "../../assets/icons/phone.svg";
import emailIcon from "../../assets/icons/email.svg";
import linkedInIcon from "../../assets/icons/linkedIn.svg";

const ContactLink = ({ href, icon, label, value, target }) => (
  <a
    className="
      flex items-center gap-6 rounded-lg p-3
      hover:bg-white/5 transition-[background-color] duration-150
      focus:bg-white/5
    "
    href={href}
    target={target}
    rel={target ? "noopener noreferrer" : undefined}
  >
    <div className="bg-blue-600 rounded-full h-12 w-12 flex items-center justify-center shrink-0">
      <img className="h-6 white-svg select-none pointer-events-none" src={icon} />
    </div>

    <div className="flex flex-col">
      <TextSm className="text-gray-400">{label}</TextSm>
      <TextMd>{value}</TextMd>
    </div>
  </a>
);

const Input = ({ className = "", ...props }) => (
  <input
    className={`
      w-full rounded-lg bg-white/5 px-6 py-4
      text-gray-100 placeholder:text-gray-400 transition
      focus:bg-white/10
      ${className}
    `}
    {...props}
  />
);

export const Contact = () => {
  const [body, setBody] = useState({});

  const sendRequest = async ()=>{
    const url = "https://script.google.com/macros/s/AKfycbxjUCTaOQ3a00haUlfJwBZk2_1p9LdTbYqGplicL5K7-oRfOANm2xyHDhELfS91RcXR/exec";
    console.log('POSTING', body);

    try{
      await fetch(url, {
        method: 'POST',
        redirect: 'follow',
        mode: 'no-cors',
        headers: {
          'Content-Type': "application/json",
        },
        body: JSON.stringify(body),
      })
    }catch(e){

    }
    
    setBody({});
    textAreaRef.current.value = "";
  }

  const disabled = !(body.name && body.email && body.message);

  const textAreaRef = useRef();

  return (
    <div className="p-9 pt-16 min-h-screen text-gray-100 flex items-center justify-center">
      <div className="w-full max-w-7xl grid grid-cols-1 xl:grid-cols-2 gap-6 items-center">
        <div className="flex flex-col gap-6 py-6">
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-6">
              <TextMd className="text-blue-600 uppercase tracking-[0.15em] font-semibold">
                Stay Connected
              </TextMd>

              <img src="/images/small-arrow.png" className="h-4" />
            </div>

            <TextLg className="font-bold text-4xl">
              Let's Work Together!
            </TextLg>

            <TextSm className="text-gray-400 max-w-xl leading-7">
              Whether you need data analytics, process automation, dashboard
              development, or a custom web application, I'd love to hear
              about your project.
            </TextSm>
          </div>

          <div className="flex flex-col gap-5 *:select-none">
            <ContactLink
              href="tel:9153151691"
              icon={phoneIcon}
              label="Phone"
              value="(915) 315-1691"
            />

            <ContactLink
              href="mailto:coltcholt@gmail.com"
              icon={emailIcon}
              label="Email"
              value="coltcholt@gmail.com"
            />

            <ContactLink
              href="https://www.linkedin.com/in/colt-holt-16070134a"
              target="_blank"
              icon={linkedInIcon}
              label="LinkedIn"
              value="linkedin.com/in/colt-holt-16070134a"
            />
          </div>
        </div>

        <div className="h-px mx-9 bg-neutral-500/15 flex lg:hidden" />

        <TextSm
          className={`
            rounded-xl py-6 h-full flex flex-col
            [&:has(.send-message-disabled:active)_.required:placeholder-shown]:outline-2
          [&:has(.send-message-disabled:active)_.required:placeholder-shown]:outline-gray-400
          `}
        >
          <div className="flex flex-col gap-6">
            <Input 
              placeholder="Full Name *" 
              className={`
                required transition-all duration-100
              `}
              value={body.name || ""}
              onChange={({ target })=>{
                setBody((prev)=>({ ...prev, name: target.value }))
              }}
            />
            <Input 
              placeholder="Email Address *"
              className={`
                required transition-all duration-100
              `}
              type="email"
              value={body.email || ""}
              onChange={({ target })=>{
                setBody((prev)=>({ ...prev, email: target.value }))
              }} 
            />
            <Input 
              placeholder="Phone Number" 
              type="tel"
              value={body.phone || ""}
              onChange={({ target })=>{
                const phone = target.value.replace(/\D/g,'').slice(0,10);
                setBody((prev)=>({ ...prev, phone }))
              }}
            />
          </div>

          <textarea
            placeholder="Write Your Message *"
            value={body.message}
            ref={textAreaRef}
            onChange={({ target })=>{
              setBody((prev)=>({ ...prev, message: target.value }))
            }}
            className={`
              required transition-all duration-100
              mt-6 h-44 w-full resize-none rounded-lg
              bg-white/5 px-6 py-4
              text-gray-100 placeholder:text-gray-400
              outline-none
              focus:bg-white/10 grow
            `}
          />
          
          <button
            className={`
              send-message mt-8 rounded-full px-6 py-3
              font-semibold text-white select-none
              shadow-lg shadow-white/5
              transition-all duration-150
              ${ disabled ? `send-message-disabled bg-gray-600 hover:bg-gray-500` : `bg-blue-600 hover:bg-blue-500`}
            `}
            onClick={()=>{
              if (disabled) return;
              sendRequest();
            }}
          >
            Send Message
          </button>
          
        </TextSm>
      </div>
    </div>
  );
};